import Vue from 'vue'
import VueRouter from 'vue-router'
import minsun_shouye from '../views/minsun_shouye/index.vue'
import minsun_jiejuefangan from '../views/minsun_jiejuefangan/index.vue'
import minsun_chanpinzhongxin from '../views/minsun_chanpinzhongxin/index.vue'
import minsun_kunying from '../views/kunying/index.vue'
import minsun_guanyuwomen from '../views/minsun_guanyuwomen/index.vue'
import minsun_mubanzhongxin from '../views/minsun_mubanzhongxin/index.vue'
import minsun_academy from '../views/minsun_academy/components/index.vue'
import Home from '../views/home/index.vue'
import Product from '../views/product/index.vue'
import KunYing from '../views/kunying/index.vue'
import Scheme from '../views/scheme/index.vue'
import About from '../views/about/index.vue'
import chuangzuo from '../views/chuangzuo/index.vue'

Vue.use(VueRouter)

const routes = [
  {
    path: '/',
    redirect: "/home"
  },
  {
    path: '/kunying',
    name: 'kunying',
    component: KunYing
  },
  {
    path: '/home',
    name: 'Home',
    component: Home
  },
  {
    path: '/product',
    name: 'Product',
    component: Product
  },
  {
    path: '/scheme',
    name: 'Scheme',
    component: Scheme
  },
  {
    path: '/about',
    name: 'About',
    component: About
  },
  {
    path: '/chuangzuo',
    name: 'chuangzuo',
    component: chuangzuo
  },
  {
    path: '/minsun_shouye',
    name: 'minsun_shouye',
    component: minsun_shouye
  },
  {
    path: '/minsun_jiejuefangan',
    name: 'minsun_jiejuefangan',
    component: minsun_jiejuefangan
  },
  {
    path: '/minsun_chanpinzhongxin',
    name: 'minsun_chanpinzhongxin',
    component: minsun_chanpinzhongxin
  },
  {
    path: '/minsun_kunying',
    name: 'minsun_kunying',
    component: minsun_kunying
  },
  {
    path: '/minsun_guanyuwomen',
    name: 'minsun_guanyuwomen',
    component: minsun_guanyuwomen
  },

  {
    path: '/minsun_academy',
    name: 'minsun_academy',
    component: minsun_academy,
  },
  {
      path: '/minsun_mubanzhongxin',
      name: 'minsun_mubanzhongxin',
      component: minsun_mubanzhongxin
    },
]
const createRouter = () => new VueRouter({
  mode: 'history',
  routes: [...routes],
});

const router = createRouter();

const originalPush = VueRouter.prototype.push
VueRouter.prototype.push = function push(location) {
  return originalPush.call(this, location).catch(err => err)
}
export default router
